module.exports = __webpack_public_path__ + "img/1996_S.8b859d97.png";